import { Cookies } from '@/shared/helpers/Cookies'
import { LazyModules } from '@/shared/LazyModules'
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: () => {
      return 'login'
    },
    meta: {
      access: ['public'],
    },
  },

  {
    path: '/login',
    name: 'login',
    component: LazyModules.LoginView,
    meta: {
      access: ['public'],
    },
  },

  {
    path: '/sms-code',
    name: 'smsCode',
    component: LazyModules.SmsCodeView,
    meta: {
      access: ['public'],
    },
  },

  {
    path: '/register',
    name: 'register',
    component: LazyModules.RegistrationView,
    meta: {
      access: ['private'],
    },
  },

  {
    path: '/first-contact',
    name: 'firstContact',
    component: LazyModules.FirstContactView,
    meta: {
      access: ['private'],
    },
  },
  {
    path: '/chats/:chatId',
    name: 'chat',
    component: LazyModules.MessengerView,
    meta: {
      access: ['private'],
    },
  },
  {
    path: '/channel/:chatId/invite',
    name: 'subscribeChat',
    component: LazyModules.MessengerView,
    meta: {
      access: ['private'],
    },
  },
  {
    path: '/policy',
    name: 'policy',
    component: LazyModules.PolicyPage,
    meta: {
      access: ['public'],
    },
  },
  {
    path: '/personal-data',
    name: 'personal-data',
    component: LazyModules.PolicyPage,
    meta: {
      access: ['public'],
    },
  },
  {
    path: '/delete-account/',
    name: 'deleteAccount',
    component: LazyModules.DeleteAccountView,
    meta: {
      access: ['private'],
    },
  },
  {
    path: '/call/outgoing',
    name: 'CallOutgoing',
    component: LazyModules.CallView,
    meta: {
      access: ['private'],
    },
  },
  {
    path: '/call/active',
    name: 'CallActive',
    component: LazyModules.CallView,
    meta: {
      access: ['private'],
    },
  },
  {
    path: '/test-error',
    name: 'testError',
    component: LazyModules.TestError,
    meta: {
      access: ['public'],
    },
  },
  {
    // Вход по ссылке-приглашению. access: public+private → открыт всем без
    // редиректа: и гостю без аккаунта, и залогиненному пользователю rooms.
    path: '/join',
    name: 'guestJoin',
    component: LazyModules.GuestJoinView,
    meta: {
      access: ['public', 'private'],
    },
  },
  {
    // Короткая ссылка-приглашение: /j/<code> (её и дают клиентам). Тот же экран
    // входа: код меняется на обычный invite_token при открытии (GuestJoinView).
    path: '/j/:code',
    name: 'guestJoinShort',
    component: LazyModules.GuestJoinView,
    meta: {
      access: ['public', 'private'],
    },
  },
  {
    // Встреча, созданная внешним сервисом по API: /m/<код>. Код ведущего пускает
    // ведущим без аккаунта, код гостя — гостем (docs/integrations/MEETINGS-API.md).
    // /m/launch#<код> — окно ведущего встречи из CRM: одноразовый запуск из карточки.
    path: '/m/:code',
    name: 'integrationLink',
    component: LazyModules.GuestJoinView,
    meta: {
      access: ['public', 'private'],
    },
  },
  {
    // Приложение ROOMS внутри карточки Битрикс24 (вкладка лида и сделки) и его
    // установка. Открывается в iframe портала; вход — сеансом Битрикса, без кук.
    path: '/crm/bitrix/app',
    name: 'crmBitrixApp',
    component: LazyModules.CrmTabView,
    meta: {
      access: ['public', 'private'],
    },
  },
  {
    path: '/crm/bitrix/install',
    name: 'crmBitrixInstall',
    component: LazyModules.CrmTabView,
    meta: {
      access: ['public', 'private'],
    },
  },
  {
    // Запись встречи из CRM: отдельное окно по одноразовой ссылке из карточки
    // (/crm/recordings/<id встречи>#<код>), дальше — по cookie просмотра.
    path: '/crm/recordings/:meetingId(\\d+)',
    name: 'crmRecording',
    component: LazyModules.CrmRecordingView,
    meta: {
      access: ['public', 'private'],
    },
  },
  {
    // Переписка встречи из CRM: так же — одноразовая ссылка из карточки
    // (/crm/chat/<id встречи>#<код>), дальше — по cookie просмотра.
    path: '/crm/chat/:meetingId(\\d+)',
    name: 'crmChat',
    component: LazyModules.CrmChatView,
    meta: {
      access: ['public', 'private'],
    },
  },
  {
    // Раздел «Интеграции»: ключи API компании (руководство компании).
    path: '/integrations',
    name: 'integrations',
    component: LazyModules.IntegrationsView,
    meta: {
      access: ['private'],
    },
  },
  {
    // Организатор создаёт комнату-встречу и делится ссылкой (только залогиненный).
    path: '/meeting',
    name: 'meeting',
    component: LazyModules.MeetingView,
    meta: {
      access: ['private'],
    },
  },
  {
    // Записи встреч/звонков (список + скачивание). Только авторизованным.
    path: '/recordings',
    name: 'recordings',
    component: LazyModules.RecordingsView,
    meta: {
      access: ['private'],
    },
  },
  {
    // Активные встречи: список идущих комнат + вход. Только авторизованным.
    path: '/rooms',
    name: 'activeRooms',
    component: LazyModules.ActiveRoomsView,
    meta: {
      access: ['private'],
    },
  },
  {
    // Просмотр записи гостем по индивидуальной ссылке из письма (домен rooms).
    // Публично: доступ подтверждается токеном в query (?t=), не аккаунтом.
    path: '/rec',
    name: 'recShared',
    component: LazyModules.RecordingSharedView,
    meta: {
      access: ['public', 'private'],
    },
  },
  {
    // Любой неизвестный путь: авторизованных ведём в мессенджер, гостей — на вход
    // (обрабатывается beforeEach по meta.access). Защита от белого экрана.
    path: '/:pathMatch(.*)*',
    redirect: () => ({ name: 'login' }),
    meta: {
      access: ['public'],
    },
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

router.beforeEach((to: any) => {
  let accessRules: string[] = to.meta.access

  if (!accessRules) {
    accessRules = []
  }

  const isPrivate = accessRules.indexOf('private') !== -1
  const isPublic = accessRules.indexOf('public') !== -1
  const isPolicy = to.name === 'policy' || to.name === 'personal-data'

  const hasCookies = Cookies.get('userId') && Cookies.get('authToken')

  if (isPrivate && isPublic) {
    return
  } else if (isPrivate && !hasCookies) {
    return { name: 'login' }
  } else if (isPublic && hasCookies && !isPolicy) {
    return 'chats/0'
  } else {
    return
  }
})

export enum ViewType {
  none = 0,
  chats = 1,
  newMessage = 2,
  editProfile = 3,
  messages = 4,
  search = 5,
  contactInfo = 6,
  editContact = 7,
  folders = 8,
  createFolder = 9,
  addChatsToFolder = 10,
  editFolder = 11,
  createGroup = 12,
  addChatsToGroup = 13,
  editGroup = 14,
  groupMembers = 15,
  groupMembersSearch = 16,
  groupAdmins = 17,
  addAdminsToGroup = 18,
  groupPermissions = 19,
  createChannel = 20,
  addChatsToChannel = 21,
  channelInfo = 22,
  editChannel = 23,
  channelMembers = 24,
  addContact = 25,
  mentions = 26,
  calendar = 27,
  bridge = 28,
}

export enum ModalType {
  none = 0,
  addContact = 1,
  addFiles = 2,
  privacyDocument = 3,
  personalDataDocument = 4,
  removeContact = 5,
  removeChat = 6,
  removeFolder = 7,
  removeChatFromFolder = 8,
  removeGroupMember = 9,
  removeGroupAdmin = 10,
  removeChannelMember = 11,
  unsubscribeChannel = 12,
  deleteMessage = 13,
  busyCall = 14,
  removeGroup = 15,
  secretNoKey = 16,
}

export default router
